import { getConstant } from '../utils';

export const getAgroEvents = getConstant('GET_AGRO_EVENTS');
export const updateAgroEvent = getConstant('UPDATE_AGRO_EVENT');
